export default {
  borderColor: '#C2C8D5',
  brandColor: '#F5AE00',

  ratio: 2, // 游戏画布与预览组件的比例
  sceneMargin: 160, // 场景默认间距

  // 画布默认的 tx、ty 值
  graph: {
    tx: 100,
    ty: 100
  },

  edgeZIndex: 1000,

  nodeTypes: {
    scene: 'scene-node',
    node: 'dag-node',
    edge: 'dag-edge'
  },

  modeTypes: {
    singleScene: 'single-scene',
    story: 'story'
  }
}
